export default __webpack_public_path__ + "static/media/valeur-creativite.f307558d.jpg";